import { render, staticRenderFns } from "./ProductCategoryFormModal.vue?vue&type=template&id=8eea32b0&scoped=true&"
import script from "./ProductCategoryFormModal.vue?vue&type=script&lang=js&"
export * from "./ProductCategoryFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eea32b0",
  null
  
)

export default component.exports